import { EnumDictionary } from '@nx-customer-apps/components';
import { CountryLanguageCodes } from '@nx-customer-apps/shared/enums';

export const LanguageCountryDictionary: Partial<EnumDictionary<CountryLanguageCodes, string>> = {
    [CountryLanguageCodes.deDE]: 'PTC.LANGUAGE_COUNTRY.GERMANY_GERMAN',
    [CountryLanguageCodes.enDE]: 'PTC.LANGUAGE_COUNTRY.GERMANY_ENGLISH'
};
